var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"file"},on:{"change":_vm.select}}),_c('progress',{attrs:{"max":"100"},domProps:{"value":_vm.progress}})])
}
var staticRenderFns = []

export { render, staticRenderFns }